import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLearnAuth } from '@/hooks/useLearnAuth';
import LoadingSpinner from '../ui/LoadingSpinner';
import { toast } from '@/hooks/use-toast';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false }) => {
  const { user, loading, isAuthenticated, isAdmin, rolesLoaded } = useLearnAuth();
  const location = useLocation();

  // Wait for both auth loading and roles loading for admin routes
  if (loading || (requireAdmin && !rolesLoaded)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/learn/auth" state={{ from: location }} replace />;
  }

  if (requireAdmin && rolesLoaded && !isAdmin) {
    toast({
      title: 'Access Denied',
      description: 'You do not have permission to access this page.',
      variant: 'destructive'
    });
    return <Navigate to="/learn/app/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
